module.exports = __webpack_public_path__ + "img/bell-on.7ab59628.svg";